import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import i18n from '../i18n';

export default function LanguageSwitcher() {
  const { t } = useTranslation();
  const [lang, setLang] = React.useState(i18n.language === 'de' ? 'de' : 'en');

  const handleChange = (_, newLang) => {
    if (!newLang) return;
    setLang(newLang);
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <Tooltip title={t('languageSwitcher.language')}>
      <ToggleButtonGroup
        value={lang}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{ height: 32 }}
      >
        <ToggleButton value="en" sx={{ px: 1.5, py: 0, fontSize: '0.75rem', fontWeight: 700, textTransform: 'none' }}>
          EN
        </ToggleButton>
        <ToggleButton value="de" sx={{ px: 1.5, py: 0, fontSize: '0.75rem', fontWeight: 700, textTransform: 'none' }}>
          DE
        </ToggleButton>
      </ToggleButtonGroup>
    </Tooltip>
  );
}
